import { defineMessages } from 'react-intl';

export default defineMessages({
  home: {
    id: 'home',
    defaultMessage: 'Home',
  },
  auditList: {
    id: 'auditList',
    defaultMessage: 'Audit Log',
  },

  auditDetail: {
    id: 'auditDetail',
    defaultMessage: 'Audit Detail',
  },
  info: {
    id: 'auditDetail.info',
    defaultMessage: 'User Info',
  },
  employe: {
    id: 'auditDetail.employe',
    defaultMessage: 'Employee Name',
  },
  company: {
    id: 'auditDetail.company',
    defaultMessage: 'Company Name',
  },
  date: {
    id: 'auditDetail.date',
    defaultMessage: 'Date & Time',
  },
  module: {
    id: 'auditDetail.module',
    defaultMessage: 'Module',
  },
  action: {
    id: 'auditDetail.action',
    defaultMessage: 'Action',
  },
  desc: {
    id: 'auditDetail.desc',
    defaultMessage: 'Description',
  },
});
